import React, { useState, useEffect } from 'react'
import classNames from 'classnames'

import Icon from '../../Icon2/Icon'
import DropDownLite from './DropDownLite'
import { advanceQueryOpts } from '../util/constant'
import { tableFilterKeyBindingHelper } from '../util/helper'

const MatchTag = ({ matchOption, updateAdvancedQueryArray, queryObj, cursorY, setDropdownOpen, isDropdownOpen, isVisible }) => {
  let [isOpen, setIsOpen] = useState(false)

  const openMatchDropdown = (e) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
    setDropdownOpen(!isOpen)
  }

  const closeDropdown = () => {
    setIsOpen(false)
    setDropdownOpen(false)
  }

  const handleChangeOption = (e, selectedOpt) => {
    updateAdvancedQueryArray({ action: 'updateMatchTag', queryObject: queryObj, selectedOption: selectedOpt })
    setIsOpen(false)
  }

  const isMatchAllActive = cursorY === queryObj.cursorY

  const handleKeyBindings = (e) => {
    const { key } = e

    if (!isVisible) return
    if (isOpen) {
      tableFilterKeyBindingHelper(e, `AdvancedQueryView__suggestion-items-dropdownlite`)
      if (key === 'Escape') {
        setIsOpen(false)
        setDropdownOpen(false)
      }
    }
    if (key === 'Enter' && isMatchAllActive && !isOpen) {
      setIsOpen(true)
      setDropdownOpen(true)
    }
  }

  useEffect(() => {
    document.addEventListener('keyup', handleKeyBindings, false)

    return () => {
      document.removeEventListener('keyup', handleKeyBindings, false)
    }
  }, [isMatchAllActive, isOpen, isVisible])

  return (
    <div
      className={classNames("query-wrapper-matchTag", isMatchAllActive && !isDropdownOpen && 'query-wrapper-matchTag-active')}
      onClick={openMatchDropdown}
      data-test-id="cs-advance-search-condition-select"
    >
      <div>{matchOption.label}</div>
      <Icon icon="CaretDownNew" version="v2" size="medium" className={classNames(isOpen && 'dropdown-caret-up-new')} />
      {isOpen && (
        <DropDownLite
          optionList={advanceQueryOpts}
          closeDropdown={closeDropdown}
          handleChangeOption={handleChangeOption}
        />
      )}
    </div>
  )
}

export default MatchTag
